<template>
	<AppScreen class="game-over-view" :scrollable="true">
		<div class="header-wrapper">
			<NGPFLogo />
			<RiskMeterSVG :level="riskLevel" />
			<BalanceTracker />
		</div>
		<div class="game-over-logo"></div>
		<div class="content">
			<p class="message wysiwyg-content" v-html="ui.game_over_message"></p>
			<div class="btn-container">
				<MarqueeButton class="play-again filled" :action="restart">{{ ui.button_text }}</MarqueeButton>
				<SocialShare class="social-share" />
			</div>
		</div>
	</AppScreen>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import AppScreen from '@/components/partials/AppScreen';
import MarqueeButton from '@/components/base/MarqueeButton';
import BalanceTracker from '@/components/game/header/BalanceTracker';
import NGPFLogo from '@/components/base/NGPFLogo';
import RiskMeterSVG from '@/components/base/RiskMeterSVG';
import SocialShare from '@/components/base/SocialShare';

export default {
	name: 'GameOver',
	components: {
		AppScreen,
		MarqueeButton,
		BalanceTracker,
		NGPFLogo,
		RiskMeterSVG,
		SocialShare,
	},
	computed: {
		...mapState({
			ui: (state) => state.global.api.data.ui.game_over[state.game.outcome],
		}),
		...mapGetters({
			average: "game/risk/average",
		}),
	},
	data() {
		return {
			riskLevel: 0,
		};
	},
	methods: {
		...mapActions([
			"getAppConfig",
		]),
		gameOverSounds() {
			if (this.$store.state.game.outcome === "win") {
				this.$store.dispatch("sound/fx/play", { id: "audience_happy" });
			} else {
				this.$store.dispatch("sound/fx/play", { id: "audience_sad" });
			}
		},
		riskAssessment() {
			if (this.average >= 80) {
				this.riskLevel = 5;
			} else if (this.average >= 60 && this.average < 80) {
				this.riskLevel = 4;
			} else if (this.average >= 40 && this.average < 60) {
				this.riskLevel = 3;
			} else if (this.average >= 20 && this.average < 40) {
				this.riskLevel = 2;
			} else {
				this.riskLevel = 1;
			}
		},
		restart() {
			this.$store.dispatch("global/analytics/trackEvent", { ec: "PlayAgain", el: `${this.$store.state.game.outcome}`, ea: 'Click' });
			this.$store.dispatch("global/api/getAppConfig");
			this.$router.push('/game/start');
			this.$store.dispatch("sound/fx/play", { id: "button_generic" });
		},
	},
	mounted() {
		this.gameOverSounds();
		this.riskAssessment();
	},
};
</script>

<style lang="scss" scoped>
	.game-over-view {
		@include swirl-background;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		padding-top: $header-height-mobile;

		@include tablet {
			overflow: hidden;
			margin-top: 0;
			padding-top: $header-height-tablet;
		}

		@include desktop {
			flex-direction: row;
			justify-content: space-between;
			overflow: hidden;
			padding-top: $header-height-desktop;
			margin-top: 0;
		}


		@include desktop-sm {
			flex-direction: row;
			justify-content: space-between;
			overflow: hidden;
			padding-top: $header-height-desktop;
			margin-top: 0;
		}
	}

	.risk-meter {
		position: absolute;
		top: 11px; // magic numer to account for border width
		left: 0;
		right: 0;
		margin: 0 auto;

		@include tablet {
			top: 13px; // magic numer to account for border width
		}

		@include desktop {
			top: 38px; // magic numer to account for border width
			left: unset;
			right: 0;
			margin-right: $risk-meter-margin;
		}

		@include desktop-sm { margin-right: $risk-meter-margin-sm; }
	}

	.content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		max-width: 650px;
		margin: 0 10vw 80px;

		@include tablet { width: 60%; }
		@include desktop { margin: 0 5vw 0 0; }
		@include desktop-sm { margin: 0 10vw 0 0; }
	}

	.game-over-logo {
		@include drop-shadow;
		margin: 80px 0 20px;
		width: 300px;
		height: 267.5px;
		background-image: url('~@/assets/images/game-over.png');
		background-size: cover;
		background-repeat: no-repeat;
		will-change: opacity;
		animation: toggle-img-mobile infinite 2s steps(2);

		@include tablet { margin-top: 100px; }

		@include desktop {
			animation: toggle-img-desktop infinite 2s steps(2);
			min-width: 400px;
			width: 400px;
			height: 355px;
			margin-top: 20px;
			margin: 0 0 0 5vw;
		}

		@include desktop-lg {
			animation: toggle-img-desktop-lg infinite 2s steps(2);
			min-width: 600px;
			width: 600px;
			height: 535px;
		}
	}

	@keyframes toggle-img-mobile {
		0% { background-position: 0px 0px; }
		100% { background-position: 0px -533px; }
	}

	@keyframes toggle-img-desktop {
		0% { background-position: 0px 0px; }
		100% { background-position: 0px -710.5px; }
	}

	@keyframes toggle-img-desktop-lg {
		0% { background-position: 0px 0px; }
		100% { background-position: 0px -1065.5px; }
	}

	.message {
		margin: 20px 0;

		&.wysiwyg-content { margin-top: 1rem; }
	}

	.btn-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		margin-top: 20px;
		max-width: 450px;

		@include mobile { flex-direction: column; }
		@include desktop {
			margin-bottom: 1rem;
			width: 70%;
		}
	}

	.marquee-btn {
		margin: 0;

		@include mobile { margin-bottom: 20px; }
	}
</style>
